module.exports = __webpack_public_path__ + "img/result-detail-output-outright01.d263a960.svg";